import React from 'react';
import { Link } from 'react-router-dom';
import { inject, observer } from "mobx-react";
import swal from 'sweetalert';

@inject("UiStore")
@observer
export class Header extends React.Component {
  //jACKY
  constructor(props){
    super(props)
    this.web3Store = props.UiStore.web3Store;
    this.connectWallet = this.connectWallet.bind(this)
  }
  
  async connectWallet(){
    try{
      await this.web3Store.connectWallet()
    }catch(e){
      swal({
        title: "错误",
        text: e.message,
        icon: "error",
      })    
    }
  }
  render() {
    const explorerUrl = this.props.UiStore.web3Store.explorerUrl || 'https://etherscan.io';
    const button = this.web3Store.defaultAccount ?
                <button className="button button_address"> 
                  {this.web3Store.defaultAccount.substr(0,6) + '...' + this.web3Store.defaultAccount.substr(-4,4)}
                </button> :
                <button className="button button_connect" onClick={this.connectWallet}>连接钱包</button>
    
    return (
    <header className="header">
        <div className="container">
          <a href="#" className="header-logo"></a>  
          {/*<span style={{color: '#ccc'}}>{this.web3Store.netIdName}</span>*/}  
          {button}
        </div>
    </header>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Header.js